/** Mga segment ng customer (M29 Phase 2): listahan, editor at mga patakaran. Shell created by WP-M29-SCHEMA2: later work packages add keys inside their group (en and fil together, no dots inside key segments). */
export const segments = {
  list: {
    title: "Mga segment",
    subtitle: "Mga naka-save na patakaran batay sa alam mo tungkol sa customer. Kusang nag-a-update ang miyembro kapag nagbago ang detalye nila, at tuwing gabi.",
    crumb: "Mga segment",
    toContacts: "Bumalik sa mga contact",
    open: "Mga segment",
    newSegment: "Bagong segment",
    tableLabel: "Mga segment",
    loading: "Nilo-load ang mga segment",
    nameColumn: "Segment",
    ruleColumn: "Patakaran",
    membersColumn: "Mga miyembro",
    usedByColumn: "Ginagamit ng",
    actionsColumn: "Mga aksyon",
    asOf: "hanggang {{time}}",
    notCounted: "Hindi pa nabibilang",
    kindStandard: "Karaniwan",
    kindSuppression: "Suppression",
    usedByContacts: "Filter ng contact",
    usedByReports: "Mga ulat",
    usedByRouting: "Routing",
    usedBySuppression: "Hindi kailanman nakakatanggap ng anunsyo",
    viewMembers: "Tingnan ang mga miyembro",
    viewMembersFor: "Tingnan ang mga miyembro ng {{name}}",
    edit: "I-edit",
    editFor: "I-edit ang {{name}}",
    remove: "Burahin",
    removeFor: "Burahin ang {{name}}",
    emptyTitle: "Wala pang segment",
    emptyBody: "Pinagsasama ng segment ang mga customer ayon sa patakaran, halimbawa mga aktibong Platinum na customer. Gamitin ito sa pag-filter ng contact, pag-route ng chat at pag-iwas sa anunsyo.",
    emptyCta: "Gawin ang unang segment",
    errorTitle: "Hindi ma-load ang mga segment",
    errorBody: "Suriin ang koneksyon at subukan muli.",
    retry: "Subukan muli",
    offTitle: "Hindi pa available ang mga segment sa workspace na ito",
    offBody: "Naka-off dito ang live chat operations. Hilingin sa Sagot contact mo na i-on ito.",
    readOnly: "Makikita mo ang mga segment pero hindi mo mababago.",
    deleteTitle: "Burahin ang {{name}}?",
    deleteBody: "Aalisin ang segment sa bawat filter na gumagamit nito. Hindi apektado ang mga customer.",
    deleteSuppressionBody: "Makakatanggap muli ng anunsyo ang mga customer sa suppression segment na ito.",
    deleteRoutingBody: "Ginagamit ng pag-route ng live chat ang segment na ito. Lalabas na tinanggal na segment ang patakarang tumutukoy rito at titigil sa pagdagdag ng puntos hanggang alisin o palitan mo ito.",
    deleteConfirm: "Burahin ang segment",
    created: "Nagawa ang segment na {{name}} na may {{count}} miyembro",
    updated: "Na-save ang segment na {{name}}",
    deleted: "Nabura ang segment na {{name}}",
    failed: "Hindi ito gumana. Subukan muli.",
  },
  editor: {
    createTitle: "Bagong segment",
    editTitle: "I-edit ang segment",
    description: "Kabilang sa segment ang mga customer na pasok sa patakaran. Nag-a-update ito kapag nagbago ang detalye nila.",
    nameLabel: "Pangalan",
    namePlaceholder: "Platinum at aktibo",
    kindLabel: "Para saan ito",
    kindStandard: "Karaniwan",
    kindStandardHint: "Grupo para sa pag-filter, pag-route at pag-ulat.",
    kindSuppression: "Suppression",
    kindSuppressionHint: "Hindi kailanman makakatanggap ng anunsyo ang mga customer na ito, anuman ang iba pang target.",
    matchLabel: "Mga customer na pasok sa",
    matchAll: "lahat ng ito",
    matchAny: "alinman dito",
    conditionsTitle: "Mga kondisyon",
    conditionLabel: "Kondisyon {{n}}",
    fieldLabel: "Field",
    opLabel: "Ay",
    valueLabel: "Halaga",
    attributeKeyLabel: "Susi ng attribute",
    attributeKeyPlaceholder: "plan_name",
    addCondition: "Magdagdag ng kondisyon",
    removeCondition: "Alisin ang kondisyon {{n}}",
    maxConditions: "Hanggang {{max}} kondisyon ang puwede sa isang segment.",
    listHint: "Paghiwalayin ang mga halaga gamit ang kuwit.",
    daysSuffix: "araw",
    save: "I-save ang segment",
    create: "Gawin ang segment",
    cancel: "Kanselahin",
    saving: "Sine-save",
    nameRequired: "Pangalanan ang segment.",
    nameTooLong: "Hanggang {{max}} character lang.",
    noConditions: "Magdagdag ng kahit isang kondisyon.",
    tooManyConditions: "Hanggang {{max}} kondisyon ang puwede sa isang segment.",
    problemAttributeKey: "Gumamit ng maliliit na titik, numero at underscore, na nagsisimula sa titik.",
    problemValue: "Maglagay ng halaga.",
    problemNumber: "Maglagay ng buong numero, zero o higit pa.",
    problemDays: "Maglagay ng buong bilang ng araw mula {{min}} hanggang {{max}}.",
    problemStatus: "Pumili ng kilalang account status.",
    problemList: "Maglagay ng kahit isang halaga.",
    problemTooMany: "Hanggang {{max}} halaga lang.",
    problemTooLong: "Hanggang {{max}} character bawat halaga.",
    nameTaken: "May segment nang may ganoong pangalan.",
    limitReached: "Naabot na ng workspace na ito ang pinakamaraming segment na puwede.",
    serverError: "Hindi tinanggap ng server ang patakaran. Tingnan ang mga naka-highlight na kondisyon.",
    discardTitle: "Itapon ang mga pagbabago mo?",
    discardBody: "Hindi pa na-save ang segment.",
    discardConfirm: "Itapon",
    keepEditing: "Ituloy ang pag-edit",
  },
  rules: {
    field: {
      tier: "Tier",
      account_status: "Account status",
      language: "Wika",
      verified: "Na-verify na pagkakakilanlan",
      last_active: "Huling nakita",
      conversations: "Mga chat",
      tags: "Mga tag ng contact",
      attribute: "Custom na attribute",
    },
    op: {
      eq: "ay",
      neq: "ay hindi",
      in: "ay isa sa",
      not_in: "ay wala sa",
      is_set: "ay may laman",
      is_not_set: "ay walang laman",
      contains: "may nakasulat na",
      gt: "ay higit sa",
      gte: "ay hindi bababa sa",
      lt: "ay mas mababa sa",
      lte: "ay hindi hihigit sa",
      has_any: "may alinman sa",
      has_all: "may lahat ng",
      has_none: "walang alinman sa",
      within_days: "sa nakalipas na",
      older_than_days: "mas matagal na kaysa sa",
    },
    status: {
      active: "Aktibo",
      restricted: "May limitasyon",
      suspended: "Suspendido",
      self_excluded: "Nag-exclude sa sarili",
      closed: "Sarado",
      kyc_pending: "Naghihintay ng verification",
    },
    yes: "Oo",
    no: "Hindi",
    joinAll: "at",
    joinAny: "o",
    days_one: "{{count}} araw",
    days_other: "{{count}} araw",
    summary: "{{field}} {{op}} {{value}}",
    summaryNoValue: "{{field}} {{op}}",
    attributeField: "Attribute na {{key}}",
    none: "Walang kondisyon",
  },
  members: {
    title: "Mga miyembro ng {{name}}",
    description: "{{count}} customer hanggang {{time}}.",
    nameColumn: "Customer",
    tierColumn: "Tier",
    statusColumn: "Status",
    lastSeenColumn: "Huling nakita",
    unnamed: "Customer na walang pangalan",
    never: "Hindi pa",
    openContact: "Buksan ang contact na {{name}}",
    loading: "Nilo-load ang mga miyembro",
    emptyTitle: "Wala pang pasok",
    emptyBody: "Wala pang customer na pasok sa patakarang ito. Nagre-refresh ang bilang kapag nagbago ang detalye ng customer at tuwing gabi.",
    errorTitle: "Hindi ma-load ang mga miyembro",
    errorBody: "Subukan muli sa ilang sandali.",
    loadMore: "Mag-load pa",
    showing: "Ipinapakita ang {{shown}} sa {{total}}",
    close: "Isara",
    privacy: "Hindi ipinapakita rito ang mga reference, e-mail address at numero ng telepono.",
  },
  filter: {
    label: "Segment",
    all: "Lahat ng customer",
    group: "Filter ng segment",
    count_one: "{{count}} customer sa segment na ito, hanggang {{time}}. Kusa itong nag-a-update.",
    count_other: "{{count}} customer sa segment na ito, hanggang {{time}}. Kusa itong nag-a-update.",
    uncounted: "Hindi pa nabibilang ang segment na ito.",
    suppression: "Suppression segment: hindi kailanman makakatanggap ng anunsyo ang mga customer na ito.",
    manage: "Pamahalaan ang mga segment",
    unknown: "Hindi kilalang segment",
    clear: "I-clear ang filter ng segment",
    inContacts: "{{shown}} sa {{total}} miyembro ay may contact record.",
  },
};
